import React, { useEffect, useState } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import "../../Assets/Styles/Products.css";
import { useParams, Link } from "react-router-dom";

function ShowProduct() {
    const { id } = useParams();
    const [product, setProduct] = useState({});
    const [faqs, setFaqs] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await Instance.get(`${config.api_url}/show-product/${id}`);
                setProduct(result.data.product);
            } catch (err) {
                setError(err);
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        setFaqs((product.faq || []).map(faq => ({ ...faq, statusFaq: false })));
    }, [product]);

    const formattedDate = (date) => {
        if (!date) return "N/A";
        return new Date(date).toLocaleDateString("fr-FR");
    };

    const toggleFaq = (index) => {
        setFaqs(prev =>
            prev.map((faq, i) =>
                i === index ? { ...faq, statusFaq: !faq.statusFaq } : faq
            )
        );
    };

    const bamboo = product.bamboo;

    return (
        <div className="a-new-product">
            <SideBar />

            <div className="show-elements-details">
                <img
                    src={`${config.img_url}/${product.productImage}`}
                    alt="product"
                    className="img-product"
                />

                {/* 🔹 PROMO */}
                <p>Promo :
                    <span>
                        {product.promo?.InPromo ? " Produit en Promo" : " Non en Promo"}
                    </span>
                </p>

                {product.promo?.InPromo && product.promo.promoType === "With_Code" && (
                    <p>Code Promo : <span>{product.promo.codePromo}</span></p>
                )}

                {product.promo?.InPromo && (
                    <p>Prix Promo : <span>{product.promo.productPricePromo} FCFA</span></p>
                )}

                <p>Prix normal : <span>{product.productPrice} FCFA</span></p>

                <p>Date de création : <span>{formattedDate(product.createdAt)}</span></p>
                <p>Produit : <span>{product.productName}</span></p>
                <p>Catégorie : <span>{product.productCategory}</span></p>
                <p>Type : <span>{product.productType || "N/A"}</span></p>
                <p>Description : <span>{product.productDescription}</span></p>
                <p>Terme / Police : <span>{product.productTerme || "N/A"}</span></p>

                {/* ==============================
                    🔹 BAMBOO SECTION
                ============================== */}
                <h1 className="faq-title">Bamboo</h1>

                {bamboo?.enabled ? (
                    <div className="bamboo-box">
                        <p>Bamboo ID : <span>{bamboo.id}</span></p>
                        <p>Nom Bamboo : <span>{bamboo.name}</span></p>
                        <p>Marque : <span>{bamboo.brand}</span></p>
                        <p>Pays : <span>{bamboo.countryCode}</span></p>
                        <p>Devise : <span>{bamboo.currencyCode}</span></p>
                        <p>Prix Bamboo : <span>{bamboo.price} {bamboo.currencyCode}</span></p>
                    </div>
                ) : (
                    <p style={{ color: "#d9534f" }}>
                        Produit non rattaché à Bamboo
                    </p>
                )}

                {/* ==============================
                    🔹 FAQ
                ============================== */}
                <h1 className="faq-title">FAQ</h1>
                <div className="faq-content">
                    {faqs.map((faq, index) => (
                        <div key={index}>
                            <div className="faq-item">
                                <p>{faq.question}</p>
                                <h1
                                    onClick={() => toggleFaq(index)}
                                    className={`arrow-faq ${faq.statusFaq ? "active" : ""}`}
                                >
                                    ⌵
                                </h1>
                            </div>

                            {faq.statusFaq && (
                                <p className="faq-description">{faq.answer}</p>
                            )}
                            <hr />
                        </div>
                    ))}
                </div>

                {/* 🔹 ACTIONS */}
                <div className="validate">
                    <Link
                        to={`/dashboard/product/add-promo/${product._id}`}
                        className="add-Promo add-new-element"
                    >
                        Ajouter une promo
                    </Link>
                </div>
            </div>

            {/* 🔹 ERROR */}
            {error && (
                <h1 style={{ color: "red", position: "fixed", left: "10%", bottom: "10%" }}>
                    {error.response?.data?.message || "Erreur serveur"}
                </h1>
            )}
        </div>
    );
}

export default ShowProduct;
